webpackJsonp([2],{

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1065),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-492faf87",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(966)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1060),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a41ae53",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(962)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1056),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-322f0a90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(978)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1071),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a421d30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1078),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e4b8d7c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1049),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-134b3d62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('div', {
    staticClass: "title-box",
    on: {
      "click": _vm.tourl
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('ul', _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "itemli",
      on: {
        "click": function($event) {
          return _vm.intourl(item)
        }
      }
    }, [_c('span', {
      staticClass: "textspan"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 1056:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('div', {
    staticClass: "title-box",
    on: {
      "click": _vm.tourl
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('ul', _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "itemli",
      on: {
        "click": function($event) {
          return _vm.intourl(item)
        }
      }
    }, [_c('span', {
      staticClass: "textspan"
    }, [_vm._v(_vm._s(item.title.rendered))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 1060:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    },
    on: {
      "click": _vm.directToPage
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('el-image', {
    staticClass: "card-img",
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "src": _vm.cardInfo.src,
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-ch"
  }, [_c('h6', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.cardInfo.infoCh))])]), _vm._v(" "), _c('div', {
    staticClass: "info-en"
  }, [_c('h6', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.cardInfo.infoEn))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1065:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('el-image', {
    staticStyle: {
      "width": "260px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.cardInfo.icon,
      "fit": "contain"
    },
    on: {
      "click": _vm.directToPage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1071:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('div', {
    staticClass: "title-box",
    on: {
      "click": _vm.tourl
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('ul', _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "itemli",
      on: {
        "click": function($event) {
          return _vm.intourl(item)
        }
      }
    }, [_c('span', {
      staticClass: "textspan"
    }, [_vm._v(_vm._s(item.titlealt != null ? item.titlealt : item.title) + _vm._s(item.numdesc != null ? item.numdesc : ''))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "swiper-box"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "box-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgLists), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      nativeOn: {
        "touchmove": function($event) {
          return _vm.stopPlay.apply(null, arguments)
        },
        "touchend": function($event) {
          return _vm.play.apply(null, arguments)
        }
      }
    }, [_c('img', {
      staticClass: "swiper-image",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.imgclick(item.blog)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-scrollbar",
    attrs: {
      "slot": "scrollbar"
    },
    slot: "scrollbar"
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardObject1
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardObject2
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardObject3
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 4,
      "lg": 4,
      "xl": 4
    }
  }, [_c('recomIcon', {
    attrs: {
      "title": "推薦"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 10,
      "lg": 10,
      "xl": 10
    }
  }, [_c('recentMessage', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.newMessageLoading),
      expression: "newMessageLoading"
    }],
    attrs: {
      "title": _vm.itemTitle2,
      "itemList": _vm.newMessageList,
      "clickurl": _vm.item2url
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 10,
      "lg": 10,
      "xl": 10
    }
  }, [_c('specialtopic', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.indexFirstLoading),
      expression: "indexFirstLoading"
    }],
    attrs: {
      "title": _vm.itemTitle1,
      "itemList": _vm.specialtopicList
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": {
        span: 10,
        offset: 4
      },
      "lg": {
        span: 10,
        offset: 4
      },
      "xl": {
        span: 10,
        offset: 4
      }
    }
  }, [_c('recentupdate', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.indexFirstLoading),
      expression: "indexFirstLoading"
    }],
    attrs: {
      "title": _vm.itemTitle,
      "itemList": _vm.indexFirstList
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 10,
      "lg": 10,
      "xl": 10
    }
  }, [_c('recommend', {
    attrs: {
      "title": _vm.itemTitle3,
      "itemList": _vm.item3
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.indexbottomLoading),
      expression: "indexbottomLoading"
    }],
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, _vm._l((_vm.indexbottom), function(bcard) {
    return _c('el-col', {
      key: bcard.icon,
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 6,
        "xl": 6
      }
    }, [_c('bottomcard', {
      attrs: {
        "cardInfo": bcard
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('div', {
    staticClass: "title-box",
    on: {
      "click": _vm.tourl
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "item-list"
  }, [_c('ul', _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "itemli",
      on: {
        "click": function($event) {
          return _vm.intourl(item)
        }
      }
    }, [_c('span', {
      staticClass: "textspan"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(983)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1076),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8cc10b5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(154);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  props: ['title']
};

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item[data-v-eb22dc2a]{background-color:#fff;padding:10px 30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;margin:10px}.item .title-box[data-v-eb22dc2a]{width:8px;height:40px;background-color:#a6dce7}.item h3[data-v-eb22dc2a]{margin-left:20px;font-size:25px;color:#000}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/recomIcon.vue"],"names":[],"mappings":"AACA,uBACE,sBAA0B,AAC1B,kBAA6B,AAC7B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,WAA4B,CAC7B,AACD,kCACI,UAAW,AACX,YAAa,AACb,wBAA0B,CAC7B,AACD,0BACI,iBAAkB,AAClB,eAAgB,AAChB,UAAe,CAClB","file":"recomIcon.vue","sourcesContent":["\n.item[data-v-eb22dc2a] {\n  background-color: #FFFFFF;\n  padding: 10px 30px 10px 30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  margin: 10px 10px 10px 10px;\n}\n.item .title-box[data-v-eb22dc2a] {\n    width: 8px;\n    height: 40px;\n    background-color: #A6DCE7;\n}\n.item h3[data-v-eb22dc2a] {\n    margin-left: 20px;\n    font-size: 25px;\n    color: #000000;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(831);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("5e2d557c", content, true, {});

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eb22dc2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "cardInfo.id"
    }
  }, [_c('div', {
    staticClass: "title-box"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  props: ['cardInfo'],
  methods: {
    directToPage: function directToPage() {
      window.open(this.cardInfo.link, '_self');
    }
  }
};

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['cardInfo'],
  methods: {
    directToPage: function directToPage() {
      if (this.cardInfo.url === 'understand') {
        window.open('https://www.amtb.tw/blog/about-master-chin-kung', '_self');
      } else {
        this.$router.push(this.cardInfo.url);
      }
    }
  }
};

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['itemList', 'title', 'clickurl'],
  methods: {
    intourl: function intourl(item) {
      window.open(item.link, '_self');
    },
    tourl: function tourl() {
      window.open(this.clickurl, '_self');
    }
  }
};

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['itemList', 'title', 'clickurl'],
  methods: {
    intourl: function intourl(item) {
      var paramer = { menuidparent: item.menuidparent, menuidchild: item.menuidchild, voice: item.voice, mp4: 1, numbers: item.id };
      this.$router.push({
        name: 'videoplay',
        query: paramer
      });
    },
    tourl: function tourl() {
      if (typeof this.clickurl !== 'undefined') {
        this.$router.push(this.clickurl);
      }
    }
  }
};

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['itemList', 'title', 'clickurl'],
  methods: {
    intourl: function intourl(item) {
      if (typeof item.contenturl !== 'undefined' && item.type === 1) {
        window.open(item.contenturl, '_self');
      } else if (typeof item.contenturl !== 'undefined' && item.type === 2) {
        var param = { categoryid: item.categoryid };
        this.$router.push({
          name: item.contenturl,
          query: param
        });
      }
    },
    tourl: function tourl() {
      if (typeof this.clickurl !== 'undefined') {
        this.$router.push(this.clickurl);
      }
    }
  }
};

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['itemList', 'title', 'clickurl'],
  methods: {
    intourl: function intourl(item) {
      if (item.type === 1) {
        var paramer = { 'categoryid': 43 };
        this.$router.push({
          name: 'lectureroom',
          query: paramer
        });
      } else {
        var _paramer = { menuidparent: item.menuidparent, menuidchild: item.menuidchild, voice: item.voice, mp4: 1, numbers: item.id };
        this.$router.push({
          name: 'videoplay',
          query: _paramer
        });
      }
    },
    tourl: function tourl() {
      if (typeof this.clickurl !== 'undefined') {
        this.$router.push(this.clickurl);
      }
    }
  }
};

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(669);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(227);

var _playcard = __webpack_require__(1031);

var _playcard2 = _interopRequireDefault(_playcard);

var _bottomcard = __webpack_require__(1026);

var _bottomcard2 = _interopRequireDefault(_bottomcard);

var _recommend = __webpack_require__(1036);

var _recommend2 = _interopRequireDefault(_recommend);

var _recentMessage = __webpack_require__(1034);

var _recentMessage2 = _interopRequireDefault(_recentMessage);

var _recentupdate = __webpack_require__(1035);

var _recentupdate2 = _interopRequireDefault(_recentupdate);

var _specialtopic = __webpack_require__(1037);

var _specialtopic2 = _interopRequireDefault(_specialtopic);

var _recomIcon = __webpack_require__(843);

var _recomIcon2 = _interopRequireDefault(_recomIcon);

var _vueAwesomeSwiper = __webpack_require__(231);

__webpack_require__(946);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      item2url: '/blog/archives/category/news/',
      imgLists: [{ url: '/static/images/banner5.jpg', blog: '/blog/archives/211' }, { url: '/static/images/banner4.jpg', blog: '/blog/archives/19469' }, { url: '/static/images/banner1.jpg', blog: '/blog/archives/1423' }, { url: '/static/images/banner2.jpg', blog: '/blog/archives/1682' }, { url: '/static/images/banner3.jpg', blog: '/blog/archives/130' }, { url: '/static/images/banner0.jpg', blog: '/blog/archives/8483' }],
      swiperOption: {
        notNextTick: true,
        autoplay: { // 自动播放
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true, // 循环
        directionType: 'horizontal', // 方向
        pagination: { // 分页器
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: { // 左右按钮
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true, // 启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。
        observeParents: true, // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新。
        setWrapperSize: true // Swiper使用flexbox布局(display: flex)，
        // 开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
      },
      active: 0,
      cardObject1: { id: 1, src: '/static/images/aboutmasterchinkung.jpg', infoCh: '認識師父', infoEn: 'ABOUT MASTER CHIN KUNG', url: 'understand' },
      cardObject2: { id: 2, src: '/static/images/collectionebook.jpg', infoCh: '精華開示', infoEn: 'ESSENCE OF DHARMA TALK', url: 'jinghua' },
      cardObject3: { id: 3, src: '/static/images/essenceoftalk.jpg', infoCh: '講記著作', infoEn: 'COLLECTION OF EBOOKS', url: 'ebooklist' },
      carousels: [{ id: 3, src: '/static/images/masterchinkong.png', name: '认识师父', label: 'about master chin kung' }],
      liitems: [{ id: 1, content: 'aaaaaa' }, { id: 2, content: 'bbbbbbbbbb' }, { id: 3, content: 'ccccccccc' }],
      itemTitle: '推薦學習',
      itemTitle1: '專欄主題',
      itemTitle2: '最新資訊',
      itemTitle3: '生活智慧',
      item3: [{ title: '答疑解惑', contenturl: '/blog/archives/category/faq', type: 1 }, { title: '故事說法', contenturl: '/blog/archives/category/story', type: 1 }, { title: '淨心法語', contenturl: '/blog/archives/category/jingxin', type: 1 }, { title: '師說新語', contenturl: '/blog/archives/category/shishuo', type: 1 }, { title: '修福有福', contenturl: '/blog/archives/category/xiufu', type: 1 }, { title: '節日開示', contenturl: '/blog/archives/category/festival', type: 1 }],
      item2: [{ title: '法音宣流', contenturl: 'http://www.amtb.org.tw/ans/ans.asp' }, { title: '聽師父說', contenturl: 'http://www.amtb.org.tw/ans/ans.asp' }, { title: '懂因果就能趨吉避凶', contenturl: 'http://www.amtb.org.tw/ans/ans.asp' }, { title: '金剛經的智言慧語', contenturl: 'http://www.amtb.org.tw/ans/ans.asp' }, { title: '法音普薰集', contenturl: 'http://www.amtb.org.tw/ans/ans.asp' }],
      newsItem: ''
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['newMessageList', 'newMessageLoading', 'specialtopicList', 'indexFirstList', 'indexFirstLoading', 'indexbottom', 'indexbottomLoading'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['INIT_NEWMESSAGELIST', 'INDEX_FIRSTLIST', 'IMG_INDEX']), {
    imgclick: function imgclick(url) {
      window.open(url, '_self');
    },
    stopPlay: function stopPlay() {
      this.mySwiper.autoplay.stop();
    },
    play: function play() {
      this.mySwiper.autoplay.start();
    }
  }),
  mounted: function mounted() {
    this.INIT_NEWMESSAGELIST();
    this.INDEX_FIRSTLIST();
    this.IMG_INDEX();
    return this.$refs.mySwiper.swiper;
  },

  components: {
    card: _playcard2.default,
    bottomcard: _bottomcard2.default,
    recommend: _recommend2.default,
    recentMessage: _recentMessage2.default,
    recentupdate: _recentupdate2.default,
    specialtopic: _specialtopic2.default,
    recomIcon: _recomIcon2.default,
    Swiper: _vueAwesomeSwiper.Swiper,
    SwiperSlide: _vueAwesomeSwiper.SwiperSlide
  }

};

/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:swiper-icons;src:url(\"data:application/font-woff;charset=utf-8;base64, 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\") format(\"woff\");font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(270deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(90deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(180deg,rgba(0,0,0,.5),transparent)}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size) / 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(-1 * var(--swiper-navigation-size) / 2);z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none!important;letter-spacing:0;text-transform:none;font-variant:normal;line-height:1}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-container-rtl .swiper-button-next:after{content:\"prev\"}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-container-rtl .swiper-button-prev:after{content:\"next\"}.swiper-button-next.swiper-button-white,.swiper-button-prev.swiper-button-white{--swiper-navigation-color:#fff}.swiper-button-next.swiper-button-black,.swiper-button-prev.swiper-button-black{--swiper-navigation-color:#000}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:opacity .3s;transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:transform .2s,top .2s}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:transform .2s,left .2s}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:transform .2s,right .2s}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white{--swiper-pagination-color:#fff}.swiper-pagination-black{--swiper-pagination-color:#000}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;animation:swiper-preloader-spin 1s infinite linear;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{to{transform:rotate(1turn)}}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube{overflow:visible}.swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube.swiper-container-rtl .swiper-slide{transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;background:#000;opacity:.6;-webkit-filter:blur(50px);filter:blur(50px);z-index:0}.swiper-container-flip{overflow:visible}.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/node_modules/swiper/css/swiper.css"],"names":[],"mappings":"AAYA,WACE,yBAA4B,AAC5B,4sEAA6sE,AAC7sE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,MACE,4BAA8B,CAC/B,AACD,kBACE,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,gBAAiB,AACjB,UAAW,AAEX,SAAW,CACZ,AACD,2CACE,qBAAuB,CACxB,AACD,gBACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,UAAW,AACX,aAAc,AACd,8BAA+B,AAC/B,sBAAwB,CACzB,AACD,wDAEE,uBAAkC,CACnC,AACD,2CACE,cAAgB,CACjB,AACD,kDACE,eAAgB,AAChB,qBAAuB,CACxB,AACD,4CACE,oCAAqC,AACrC,aAAe,CAChB,AACD,cACE,cAAe,AACf,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,6BAA+B,CAChC,AACD,8BACE,iBAAmB,CACpB,AAED,wEAEE,WAAa,CACd,AACD,6CACE,uBAAwB,AACxB,oCAAuC,CACxC,AAED,qBACE,kBAAoB,CACrB,AACD,+SAOE,2BAA6B,CAC9B,AACD,8LAIE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,UAAY,CACb,AACD,+CACE,mEAAiF,CAClF,AACD,gDACE,kEAAkF,CACnF,AACD,8CACE,iEAAgF,CACjF,AACD,iDACE,mEAAmF,CACpF,AAED,2CACE,cAAe,AACf,qBAAsB,AAEtB,uBAAyB,CAE1B,AACD,8DACE,YAAc,CACf,AACD,yDACE,6BAA+B,CAChC,AACD,uEACE,4BAA8B,CAC/B,AACD,qEACE,4BAA8B,CAC/B,AACD,MACE,6BAA+B,CAIhC,AACD,wCAEE,kBAAmB,AACnB,QAAS,AACT,oDAAqD,AACrD,qCAAsC,AACtC,wDAAyD,AACzD,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,mBAAoB,AACpB,uBAAwB,AACxB,8DAAiE,CAClE,AACD,sFAEE,YAAc,AACd,YAAa,AACb,mBAAqB,CACtB,AACD,oDAEE,yBAA0B,AAC1B,wCAAyC,AACzC,8BAAgC,AAChC,iBAAkB,AAClB,oBAAqB,AACrB,oBAAsB,AACtB,aAAe,CAChB,AACD,8DAEE,UAAW,AACX,UAAY,CACb,AACD,0EAEE,cAAgB,CACjB,AACD,8DAEE,WAAY,AACZ,SAAW,CACZ,AACD,0EAEE,cAAgB,CACjB,AACD,gFAEE,8BAAmC,CACpC,AACD,gFAEE,8BAAmC,CACpC,AACD,oBACE,YAAc,CACf,AAMD,mBACE,kBAAmB,AACnB,kBAAmB,AACnB,uBAA0B,AAC1B,wBAAgC,AAChC,UAAY,CACb,AACD,4CACE,SAAW,CACZ,AAED,8GAGE,YAAa,AACb,OAAQ,AACR,UAAY,CACb,AAED,mCACE,gBAAiB,AACjB,WAAa,CACd,AACD,6DACE,qBAAuB,AACvB,iBAAmB,CACpB,AAID,6IACE,kBAAoB,CACrB,AACD,yEACE,oBAAuB,CACxB,AACD,8EACE,oBAAuB,CACxB,AACD,yEACE,oBAAuB,CACxB,AACD,8EACE,oBAAuB,CACxB,AACD,0BACE,UAAW,AACX,WAAY,AACZ,qBAAsB,AACtB,mBAAoB,AACpB,gBAAiB,AACjB,UAAa,CACd,AACD,gCACE,YAAa,AACb,SAAU,AACV,UAAW,AACX,gBAAiB,AACjB,wBAAyB,AACtB,qBAAsB,AACjB,eAAiB,CAC1B,AACD,uDACE,cAAgB,CACjB,AACD,iCACE,UAAW,AACX,mEAAsE,CACvE,AACD,sDACE,WAAY,AACZ,QAAS,AACT,+BAAqC,CACtC,AACD,gFACE,aAAc,AACd,aAAe,CAChB,AACD,wFACE,QAAS,AACT,2BAA4B,AAC5B,SAAW,CACZ,AACD,kHACE,qBAAsB,AACtB,gCAAuC,CACxC,AACD,kFACE,YAAc,CACf,AACD,0FACE,SAAU,AACV,2BAA4B,AAC5B,kBAAoB,CACrB,AACD,oHACE,iCAAwC,CACzC,AACD,+GACE,kCAAyC,CAC1C,AAED,+BACE,2BAAgC,AAChC,iBAAmB,CACpB,AACD,mEACE,oEAAsE,AACtE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,yBAA2B,CAC5B,AACD,yFACE,0BAA4B,CAC7B,AACD,6JAEE,WAAY,AACZ,WAAY,AACZ,OAAQ,AACR,KAAO,CACR,AACD,6JAEE,UAAW,AACX,YAAa,AACb,OAAQ,AACR,KAAO,CACR,AACD,yBACE,8BAAmC,CACpC,AACD,yBACE,8BAAmC,CACpC,AACD,wBACE,YAAc,CACf,AAED,kBACE,mBAAoB,AACpB,kBAAmB,AACnB,sBAAuB,AACvB,yBAA+B,CAChC,AACD,+CACE,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,WAAY,AACZ,WAAY,AACZ,SAAW,CACZ,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,OAAQ,AACR,WAAY,AACZ,UAAW,AACX,UAAY,CACb,AACD,uBACE,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,0BAA+B,AAC/B,mBAAoB,AACpB,OAAQ,AACR,KAAO,CACR,AACD,8BACE,WAAa,CACd,AACD,uBACE,YAAc,CACf,AACD,uBACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,uBAAwB,AACxB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,oFAGE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,qBACE,WAAa,CACd,AAOD,uBACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,kBAAmB,AACnB,iBAAkB,AAClB,WAAY,AACZ,qBAAsB,AACtB,mDAAoD,AACpD,sBAAuB,AACvB,yEAA2E,AAC3E,kBAAmB,AACnB,4BAA8B,CAC/B,AACD,6BACE,6BAA+B,CAChC,AACD,6BACE,6BAA+B,CAChC,AACD,iCACE,GACE,uBAA0B,CAC3B,CACF,AAED,uCACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,oBAAqB,AACrB,UAAW,AACX,aAAe,CAChB,AACD,gEACE,mCAAqC,CACtC,AACD,qCACE,oBAAqB,AACrB,2BAA6B,CAC9B,AACD,mDACE,mBAAqB,CACtB,AACD,6GAEE,mBAAqB,CACtB,AACD,uBACE,gBAAkB,CACnB,AACD,qCACE,oBAAqB,AACrB,mCAAoC,AAC5B,2BAA4B,AACpC,UAAW,AACX,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,WAAa,CACd,AACD,mDACE,mBAAqB,CACtB,AACD,0DACE,uBAAyB,CAC1B,AACD,6GAEE,mBAAqB,CACtB,AACD,wLAIE,oBAAqB,AACrB,kBAAoB,CACrB,AACD,sMAIE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,2CACE,kBAAmB,AACnB,OAAQ,AACR,SAAY,AACZ,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,WAAa,AACb,0BAA2B,AAC3B,kBAAmB,AACnB,SAAW,CACZ,AACD,uBACE,gBAAkB,CACnB,AACD,qCACE,oBAAqB,AACrB,mCAAoC,AAC5B,2BAA4B,AACpC,SAAW,CACZ,AACD,mDACE,mBAAqB,CACtB,AACD,6GAEE,mBAAqB,CACtB,AACD,sMAIE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC","file":"swiper.css","sourcesContent":["/**\n * Swiper 5.4.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://swiperjs.com\n *\n * Copyright 2014-2020 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: May 20, 2020\n */\n\n@font-face {\n  font-family: 'swiper-icons';\n  src: url(\"data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n:root {\n  --swiper-theme-color: #007aff;\n}\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-container-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n/* 3D Effects */\n.swiper-container-3d {\n  perspective: 1200px;\n}\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* CSS Mode */\n.swiper-container-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  text-transform: none;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  left: 10px;\n  right: auto;\n}\n.swiper-button-prev:after,\n.swiper-container-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-container-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n.swiper-button-prev.swiper-button-white,\n.swiper-button-next.swiper-button-white {\n  --swiper-navigation-color: #ffffff;\n}\n.swiper-button-prev.swiper-button-black,\n.swiper-button-next.swiper-button-black {\n  --swiper-navigation-color: #000000;\n}\n.swiper-button-lock {\n  display: none;\n}\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 100%;\n  background: #000;\n  opacity: 0.2;\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform, 200ms top;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms left;\n}\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-white {\n  --swiper-pagination-color: #ffffff;\n}\n.swiper-pagination-black {\n  --swiper-pagination-color: #000000;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-container-horizontal > .swiper-scrollbar {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-container-vertical > .swiper-scrollbar {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n:root {\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  */\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  animation: swiper-preloader-spin 1s infinite linear;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube {\n  overflow: visible;\n}\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.6;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n  z-index: 0;\n}\n.swiper-container-flip {\n  overflow: visible;\n}\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item[data-v-134b3d62]{background-color:#fff;padding:10px 10px 0;position:relative;overflow:hidden;text-align:center;margin:10px 10px 0}.item .title-box[data-v-134b3d62],.item[data-v-134b3d62]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item .title-box[data-v-134b3d62]{border:1px solid #838383;border-radius:20px;width:100%;margin:10px;padding:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item .title-box h3[data-v-134b3d62]{color:#7d7d7d;font-size:19px}.item .item-list[data-v-134b3d62]{margin:5px 10px 0 30px;padding:5px 10px 5px 30px}.item .item-list h3[data-v-134b3d62]{padding:10px;color:#838383;font-size:18px}.item .item-list li[data-v-134b3d62]{color:#000;text-align:left;list-style-type:square;cursor:pointer;line-height:25px}.itemli:hover .textspan[data-v-134b3d62]{color:#3a5fcd}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/specialtopic.vue"],"names":[],"mappings":"AACA,uBACE,sBAA0B,AAC1B,oBAA0B,AAQ1B,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,kBAAyB,CAC1B,AACD,yDAZE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAyBhC,AAnBD,kCACI,yBAA0B,AAC1B,mBAAoB,AACpB,WAAY,AACZ,YAA4B,AAC5B,aAA6B,AAQ7B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,qCACM,cAAe,AACf,cAAgB,CACrB,AACD,kCACI,uBAAwB,AACxB,yBAA2B,CAC9B,AACD,qCACM,aAA6B,AAC7B,cAAe,AACf,cAAgB,CACrB,AACD,qCACM,WAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,gBAAkB,CACvB,AACD,yCACE,aAAe,CAChB","file":"specialtopic.vue","sourcesContent":["\n.item[data-v-134b3d62] {\n  background-color: #FFFFFF;\n  padding: 10px 10px 0 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  margin: 10px 10px 0 10px;\n}\n.item .title-box[data-v-134b3d62] {\n    border: #838383 1px solid;\n    border-radius: 20px;\n    width: 100%;\n    margin: 10px 10px 10px 10px;\n    padding: 10px 10px 10px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.item .title-box h3[data-v-134b3d62] {\n      color: #7d7d7d;\n      font-size: 19px;\n}\n.item .item-list[data-v-134b3d62] {\n    margin: 5px 10px 0 30px;\n    padding: 5px 10px 5px 30px;\n}\n.item .item-list h3[data-v-134b3d62] {\n      padding: 10px 10px 10px 10px;\n      color: #838383;\n      font-size: 18px;\n}\n.item .item-list li[data-v-134b3d62] {\n      color: #000000;\n      text-align: left;\n      list-style-type: square;\n      cursor: pointer;\n      line-height: 25px;\n}\n.itemli:hover .textspan[data-v-134b3d62] {\n  color: #3A5FCD;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item[data-v-322f0a90]{background-color:#fff;padding:10px 10px 0;position:relative;overflow:hidden;text-align:center;margin:10px 10px 0}.item .title-box[data-v-322f0a90],.item[data-v-322f0a90]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item .title-box[data-v-322f0a90]{border:1px solid #838383;border-radius:20px;width:100%;margin:10px;padding:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item .title-box h3[data-v-322f0a90]{color:#7d7d7d;font-size:19px}.item .item-list[data-v-322f0a90]{margin:5px 10px 10px 30px;padding:5px 10px 10px 30px}.item .item-list h3[data-v-322f0a90]{padding:10px;color:#838383;font-size:18px}.item .item-list li[data-v-322f0a90]{color:#000;text-align:left;list-style-type:square;cursor:pointer;line-height:25px;transition:1s;-moz-transition:1s;-webkit-transition:1s;-o-transition:1s}.itemli:hover .textspan[data-v-322f0a90]{color:#3a5fcd}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/recentMessage.vue"],"names":[],"mappings":"AACA,uBACE,sBAA0B,AAC1B,oBAA0B,AAQ1B,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,kBAA2B,CAC5B,AACD,yDAZE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAyBhC,AAnBD,kCACI,yBAA0B,AAC1B,mBAAoB,AACpB,WAAY,AACZ,YAA4B,AAC5B,aAA6B,AAQ7B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,qCACM,cAAe,AACf,cAAgB,CACrB,AACD,kCACI,0BAA2B,AAC3B,0BAA4B,CAC/B,AACD,qCACM,aAA6B,AAC7B,cAAe,AACf,cAAgB,CACrB,AACD,qCACM,WAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AAEpB,sBAAuB,AAEvB,gBAAkB,CAEvB,AACD,yCACE,aAAe,CAChB","file":"recentMessage.vue","sourcesContent":["\n.item[data-v-322f0a90] {\n  background-color: #FFFFFF;\n  padding: 10px 10px 0 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  margin: 10px 10px 0px 10px;\n}\n.item .title-box[data-v-322f0a90] {\n    border: #838383 1px solid;\n    border-radius: 20px;\n    width: 100%;\n    margin: 10px 10px 10px 10px;\n    padding: 10px 10px 10px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.item .title-box h3[data-v-322f0a90] {\n      color: #7d7d7d;\n      font-size: 19px;\n}\n.item .item-list[data-v-322f0a90] {\n    margin: 5px 10px 10px 30px;\n    padding: 5px 10px 10px 30px;\n}\n.item .item-list h3[data-v-322f0a90] {\n      padding: 10px 10px 10px 10px;\n      color: #838383;\n      font-size: 18px;\n}\n.item .item-list li[data-v-322f0a90] {\n      color: #000000;\n      text-align: left;\n      list-style-type: square;\n      cursor: pointer;\n      line-height: 25px;\n      transition: 1s;\n      -moz-transition: 1s;\n      /* Firefox 4 */\n      -webkit-transition: 1s;\n      /* Safari and Chrome */\n      -o-transition: 1s;\n      /* Opera */\n}\n.itemli:hover .textspan[data-v-322f0a90] {\n  color: #3A5FCD;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item .img-box[data-v-3a41ae53]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item[data-v-3a41ae53]{cursor:pointer;background-color:#e7f5f9;padding:20px;border-radius:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;text-align:center;margin:25px 0 0 25px}.item .img-box[data-v-3a41ae53]{transition:1s;-moz-transition:1s;-webkit-transition:1s;-o-transition:1s;margin-bottom:1rem}.item .info-ch[data-v-3a41ae53]{width:100%;padding:0 10px}.item .info-ch h6[data-v-3a41ae53]{overflow:hidden;font-size:1.5rem;font-weight:500;line-height:1.2;white-space:nowrap;text-overflow:ellipsis;color:#808285;letter-spacing:4px}.item .info-en[data-v-3a41ae53]{width:100%;padding:10px 20px}.item .info-en h6[data-v-3a41ae53]{overflow:hidden;font-size:1rem;font-family:PingFang SC,Helvetica Neue,Hiragino Sans GB,Segoe UI,Microsoft YaHei,\\\\5FAE\\8F6F\\96C5\\9ED1,sans-serif;letter-spacing:.5px;white-space:nowrap;text-overflow:ellipsis;color:#808285}.img-box[data-v-3a41ae53]:hover{transform:scale(1.1);-ms-transform:scale(1.1);-moz-transform:scale(1.1);-webkit-transform:scale(1.1);-o-transform:scale(1.1)}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/playcard3.vue"],"names":[],"mappings":"AAEA,gCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,uBACE,eAAgB,AAChB,yBAA0B,AAC1B,aAA6B,AAC7B,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,kBAAmB,AACnB,oBAAsB,CACvB,AACD,gCACI,cAAe,AACf,mBAAoB,AAEpB,sBAAuB,AAEvB,iBAAkB,AAElB,kBAAoB,CACvB,AACD,gCACI,WAAY,AACZ,cAAgB,CACnB,AACD,mCACM,gBAAiB,AACjB,iBAAkB,AAClB,gBAAiB,AACjB,gBAAiB,AACjB,mBAAoB,AACpB,uBAAwB,AACxB,cAAe,AACf,kBAAoB,CACzB,AACD,gCACI,WAAY,AACZ,iBAAmB,CACtB,AACD,mCACM,gBAAiB,AACjB,eAAkB,AAClB,kHAAoH,AACpH,oBAAsB,AACtB,mBAAoB,AACpB,uBAAwB,AACxB,aAAe,CACpB,AACD,gCACE,qBAA2B,AAC3B,yBAA+B,AAE/B,0BAAgC,AAEhC,6BAAmC,AAEnC,uBAA8B,CAC/B","file":"playcard3.vue","sourcesContent":["\n@charset \"UTF-8\";\n.item .img-box[data-v-3a41ae53] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.item[data-v-3a41ae53] {\n  cursor: pointer;\n  background-color: #E7F5F9;\n  padding: 20px 20px 20px 20px;\n  border-radius: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  text-align: center;\n  margin: 25px 0 0 25px;\n}\n.item .img-box[data-v-3a41ae53] {\n    transition: 1s;\n    -moz-transition: 1s;\n    /* Firefox 4 */\n    -webkit-transition: 1s;\n    /* Safari and Chrome */\n    -o-transition: 1s;\n    /* Opera */\n    margin-bottom: 1rem;\n}\n.item .info-ch[data-v-3a41ae53] {\n    width: 100%;\n    padding: 0 10px;\n}\n.item .info-ch h6[data-v-3a41ae53] {\n      overflow: hidden;\n      font-size: 1.5rem;\n      font-weight: 500;\n      line-height: 1.2;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      color: #808285;\n      letter-spacing: 4px;\n}\n.item .info-en[data-v-3a41ae53] {\n    width: 100%;\n    padding: 10px 20px;\n}\n.item .info-en h6[data-v-3a41ae53] {\n      overflow: hidden;\n      font-size: 1.0rem;\n      font-family: \"PingFang SC\", \"Helvetica Neue\", \"Hiragino Sans GB\", \"Segoe UI\", \"Microsoft YaHei\", \"微软雅黑\", sans-serif;\n      letter-spacing: 0.5px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      color: #808285;\n}\n.img-box[data-v-3a41ae53]:hover {\n  transform: scale(1.1, 1.1);\n  -ms-transform: scale(1.1, 1.1);\n  /* IE 9 */\n  -moz-transform: scale(1.1, 1.1);\n  /* Firefox */\n  -webkit-transform: scale(1.1, 1.1);\n  /* Safari 和 Chrome */\n  -o-transform: scale(1.1, 1.1);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item .img-box[data-v-492faf87]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item .img-box[data-v-492faf87],.item[data-v-492faf87]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.item[data-v-492faf87]{background-color:#fff;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-ms-grid-column-align:center;justify-items:center;-ms-flex-line-pack:center;align-content:center;padding-top:30px;transition:1s;-moz-transition:1s;-webkit-transition:1s;-o-transition:1s}.item .img-box[data-v-492faf87]{margin-bottom:1rem}.item[data-v-492faf87]:hover{transform:scale(1.1);-ms-transform:scale(1.1);-moz-transform:scale(1.1);-webkit-transform:scale(1.1);-o-transform:scale(1.1)}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/bottomcard.vue"],"names":[],"mappings":"AAEA,gCAOE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,uDAVE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CA6B7B,AAxBD,uBACE,sBAA0B,AAI1B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,6BAA8B,AAC1B,qBAAsB,AAI1B,0BAA2B,AACvB,qBAAsB,AAC1B,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AAEpB,sBAAuB,AAEvB,gBAAkB,CAEnB,AACD,gCACI,kBAAoB,CACvB,AACD,6BACE,qBAA2B,AAC3B,yBAA+B,AAE/B,0BAAgC,AAEhC,6BAAmC,AAEnC,uBAA8B,CAC/B","file":"bottomcard.vue","sourcesContent":["\n@charset \"UTF-8\";\n.item .img-box[data-v-492faf87] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.item[data-v-492faf87] {\n  background-color: #FFFFFf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-grid-column-align: center;\n      justify-items: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  padding-top: 30px;\n  transition: 1s;\n  -moz-transition: 1s;\n  /* Firefox 4 */\n  -webkit-transition: 1s;\n  /* Safari and Chrome */\n  -o-transition: 1s;\n  /* Opera */\n}\n.item .img-box[data-v-492faf87] {\n    margin-bottom: 1rem;\n}\n.item[data-v-492faf87]:hover {\n  transform: scale(1.1, 1.1);\n  -ms-transform: scale(1.1, 1.1);\n  /* IE 9 */\n  -moz-transform: scale(1.1, 1.1);\n  /* Firefox */\n  -webkit-transform: scale(1.1, 1.1);\n  /* Safari 和 Chrome */\n  -o-transform: scale(1.1, 1.1);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item[data-v-6a421d30]{background-color:#fff;padding:0 10px 10px;position:relative;overflow:hidden;text-align:center;margin:0 10px 10px}.item .title-box[data-v-6a421d30],.item[data-v-6a421d30]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item .title-box[data-v-6a421d30]{border:1px solid #838383;border-radius:20px;width:100%;margin:10px;padding:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item .title-box h3[data-v-6a421d30]{color:#7d7d7d;font-size:19px}.item .item-list[data-v-6a421d30]{margin:5px 10px 0 30px;padding:5px 10px 5px 30px}.item .item-list h3[data-v-6a421d30]{padding:10px;color:#838383;font-size:18px}.item .item-list li[data-v-6a421d30]{color:#000;text-align:left;list-style-type:square;cursor:pointer;line-height:25px;transition:1s;-moz-transition:1s;-webkit-transition:1s;-o-transition:1s}.itemli:hover .textspan[data-v-6a421d30]{color:#3a5fcd}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/recentupdate.vue"],"names":[],"mappings":"AACA,uBACE,sBAA0B,AAC1B,oBAA0B,AAQ1B,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,kBAA2B,CAC5B,AACD,yDAZE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAyBhC,AAnBD,kCACI,yBAA0B,AAC1B,mBAAoB,AACpB,WAAY,AACZ,YAA4B,AAC5B,aAA6B,AAQ7B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,qCACM,cAAe,AACf,cAAgB,CACrB,AACD,kCACI,uBAAwB,AACxB,yBAA2B,CAC9B,AACD,qCACM,aAA6B,AAC7B,cAAe,AACf,cAAgB,CACrB,AACD,qCACM,WAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AAEpB,sBAAuB,AAEvB,gBAAkB,CAEvB,AACD,yCACE,aAAe,CAChB","file":"recentupdate.vue","sourcesContent":["\n.item[data-v-6a421d30] {\n  background-color: #FFFFFF;\n  padding: 0 10px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  margin: 0px 10px 10px 10px;\n}\n.item .title-box[data-v-6a421d30] {\n    border: #838383 1px solid;\n    border-radius: 20px;\n    width: 100%;\n    margin: 10px 10px 10px 10px;\n    padding: 10px 10px 10px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.item .title-box h3[data-v-6a421d30] {\n      color: #7d7d7d;\n      font-size: 19px;\n}\n.item .item-list[data-v-6a421d30] {\n    margin: 5px 10px 0 30px;\n    padding: 5px 10px 5px 30px;\n}\n.item .item-list h3[data-v-6a421d30] {\n      padding: 10px 10px 10px 10px;\n      color: #838383;\n      font-size: 18px;\n}\n.item .item-list li[data-v-6a421d30] {\n      color: #000000;\n      text-align: left;\n      list-style-type: square;\n      cursor: pointer;\n      line-height: 25px;\n      transition: 1s;\n      -moz-transition: 1s;\n      /* Firefox 4 */\n      -webkit-transition: 1s;\n      /* Safari and Chrome */\n      -o-transition: 1s;\n      /* Opera */\n}\n.itemli:hover .textspan[data-v-6a421d30] {\n  color: #3A5FCD;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";.content[data-v-8cc10b5c]{display:-webkit-box;display:-ms-flexbox;display:flex;background-color:#fff}.carousel-item[data-v-8cc10b5c],.content[data-v-8cc10b5c]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.carousel-item[data-v-8cc10b5c]{  background:#fff; display:flex; justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (max-device-width:780px){.carousel-img[data-v-8cc10b5c]{max-width:780px;_width:expression(this.width > 780 ? \"780px\":this.width)}}@media (max-device-width:900px){.carousel-img[data-v-8cc10b5c]{max-width:900px;_width:expression(this.width > 900 ? \"900px\":this.width)}}@media (max-device-width:1080px){.carousel-img[data-v-8cc10b5c]{max-width:expression(this.width);_width:expression(this.width > 1080 ? \"1080px\":this.width)}}@media (max-device-width:375px){.carousel-img[data-v-8cc10b5c]{max-width:375px;_width:expression(this.width > 1080 ? \"1080px\":this.width)}.carousel-div[data-v-8cc10b5c]{max-height:100px}.carousel-item[data-v-8cc10b5c],.el-carousel__item[data-v-8cc10b5c]{max-height:100px!important}.el-carousel__item[data-v-8cc10b5c]:nth-child(2n),.el-carousel__item[data-v-8cc10b5c]:nth-child(odd){background-color:#fff}.el-carousel__container[data-v-8cc10b5c]{max-height:100px;height:100px}}.swiper-image[data-v-8cc10b5c]{width:100%}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/page/Index/index.vue"],"names":[],"mappings":"AAYA,iBAWC,AArBD,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAKd,qBAA0B,CAC3B,AACD,0DANE,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAchC,AAXD,gCACE,kBAAoB,AACpB,cAAe,AAKf,wBAAyB,AACzB,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,gCACA,+BACI,gBAAiB,CACjB,uDAA4D,CAC/D,CACA,AACD,gCACA,+BACI,gBAAiB,CACjB,uDAA4D,CAC/D,CACA,AACD,iCACA,+BACI,iCAAkC,CAClC,yDAA8D,CACjE,CACA,AACD,gCACA,+BACI,gBAAiB,CACjB,yDAA8D,CACjE,AACD,+BACI,gBAAkB,CACrB,AAID,oEACI,0BAA6B,CAChC,AAID,qGACI,qBAA0B,CAC7B,AACD,yCACI,iBAAkB,AAClB,YAAc,CACjB,CACA,AACD,+BACE,UAAY,CACb","file":"index.vue","sourcesContent":["\n@charset \"UTF-8\";\n.content[data-v-8cc10b5c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  background-color: #ffffff;\n}\n  .carousel-item[data-v-8cc10b5c] {\n    background: white;\n   display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n   justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@media (max-device-width: 780px) {\n.carousel-img[data-v-8cc10b5c] {\n    max-width: 780px;\n    _width: expression(this.width > 780 ? \"780px\" : this.width);\n}\n}\n@media (max-device-width: 900px) {\n.carousel-img[data-v-8cc10b5c] {\n    max-width: 900px;\n    _width: expression(this.width > 900 ? \"900px\" : this.width);\n}\n}\n@media (max-device-width: 1080px) {\n.carousel-img[data-v-8cc10b5c] {\n    max-width: expression(this.width);\n    _width: expression(this.width > 1080 ? \"1080px\" : this.width);\n}\n}\n@media (max-device-width: 375px) {\n.carousel-img[data-v-8cc10b5c] {\n    max-width: 375px;\n    _width: expression(this.width > 1080 ? \"1080px\" : this.width);\n}\n.carousel-div[data-v-8cc10b5c] {\n    max-height: 100px;\n}\n.carousel-item[data-v-8cc10b5c] {\n    max-height: 100px !important;\n}\n.el-carousel__item[data-v-8cc10b5c] {\n    max-height: 100px !important;\n}\n.el-carousel__item[data-v-8cc10b5c]:nth-child(2n) {\n    background-color: #FFFFFF;\n}\n.el-carousel__item[data-v-8cc10b5c]:nth-child(2n+1) {\n    background-color: #ffffff;\n}\n.el-carousel__container[data-v-8cc10b5c] {\n    max-height: 100px;\n    height: 100px;\n}\n}\n.swiper-image[data-v-8cc10b5c] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(647)(true);
// imports


// module
exports.push([module.i, ".item[data-v-e4b8d7c0]{background-color:#fff;padding:0 10px 10px;position:relative;overflow:hidden;text-align:center;margin:0 10px 10px}.item .title-box[data-v-e4b8d7c0],.item[data-v-e4b8d7c0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item .title-box[data-v-e4b8d7c0]{border:1px solid #838383;border-radius:20px;width:100%;margin:10px;padding:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item .title-box h3[data-v-e4b8d7c0]{color:#7d7d7d;font-size:19px}.item .item-list[data-v-e4b8d7c0]{margin:5px 10px 10px 30px;padding:5px 10px 10px 30px}.item .item-list h3[data-v-e4b8d7c0]{padding:10px;color:#838383;font-size:18px}.item .item-list li[data-v-e4b8d7c0]{color:#000;text-align:left;list-style-type:square;cursor:pointer;line-height:25px;transition:1s;-moz-transition:1s;-webkit-transition:1s;-o-transition:1s}.itemli:hover .textspan[data-v-e4b8d7c0]{color:#3a5fcd}", "", {"version":3,"sources":["E:/code/amituofo_old/album-front/src/components/recommend.vue"],"names":[],"mappings":"AACA,uBACE,sBAA0B,AAC1B,oBAA4B,AAQ5B,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,kBAA2B,CAC5B,AACD,yDAZE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAyBhC,AAnBD,kCACI,yBAA0B,AAC1B,mBAAoB,AACpB,WAAY,AACZ,YAA4B,AAC5B,aAA6B,AAQ7B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,qCACM,cAAe,AACf,cAAgB,CACrB,AACD,kCACI,0BAA2B,AAC3B,0BAA4B,CAC/B,AACD,qCACM,aAA6B,AAC7B,cAAe,AACf,cAAgB,CACrB,AACD,qCACM,WAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AAEpB,sBAAuB,AAEvB,gBAAkB,CAEvB,AACD,yCACE,aAAe,CAChB","file":"recommend.vue","sourcesContent":["\n.item[data-v-e4b8d7c0] {\n  background-color: #FFFFFF;\n  padding: 0px 10px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  margin: 0px 10px 10px 10px;\n}\n.item .title-box[data-v-e4b8d7c0] {\n    border: #838383 1px solid;\n    border-radius: 20px;\n    width: 100%;\n    margin: 10px 10px 10px 10px;\n    padding: 10px 10px 10px 10px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.item .title-box h3[data-v-e4b8d7c0] {\n      color: #7d7d7d;\n      font-size: 19px;\n}\n.item .item-list[data-v-e4b8d7c0] {\n    margin: 5px 10px 10px 30px;\n    padding: 5px 10px 10px 30px;\n}\n.item .item-list h3[data-v-e4b8d7c0] {\n      padding: 10px 10px 10px 10px;\n      color: #838383;\n      font-size: 18px;\n}\n.item .item-list li[data-v-e4b8d7c0] {\n      color: #000000;\n      text-align: left;\n      list-style-type: square;\n      cursor: pointer;\n      line-height: 25px;\n      transition: 1s;\n      -moz-transition: 1s;\n      /* Firefox 4 */\n      -webkit-transition: 1s;\n      /* Safari and Chrome */\n      -o-transition: 1s;\n      /* Opera */\n}\n.itemli:hover .textspan[data-v-e4b8d7c0] {\n  color: #3A5FCD;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(904);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("6ac86c74", content, true, {});

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(912);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("75d09522", content, true, {});

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(920);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("65e9c0a8", content, true, {});

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(924);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("ad288e04", content, true, {});

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("790bd7a8", content, true, {});

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("0864180c", content, true, {});

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(941);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("6c208326", content, true, {});

/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(648)("0d293bd4", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.316e5f049a55d6f86c61.1752026581309.js